import React from 'react';
import './App.css';
import Routes from "./pages/routes";

const App: React.FC = () => {
  return (
    <div className="App">
      <Routes />
    </div>
  );
};

export default App;
